<script>
import { Bar } from "vue-chartjs";
//var color = Chart.helpers.color;

export default {
  extends: Bar,
  props: {
    stats: {},
    months: {},
    profits: {}
  },
  data: () => ({
    chartdata: {
      labels: [],
      datasets: [
        {
          backgroundColor: "rgba(38,171,94, 0.3)",
          barThickness: 15,
          data: [0]
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false
            }
          }
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              padding: 8,
            },
            gridLines: {
              drawBorder: false
            }
          }
        ]
      }
    }
  }),
  mounted() {
    const colours = this.profits.map((value) => value < 0 ? 'rgba(248,48,48, 0.3)' : 'rgba(38,171,94, 0.3)');
    this.options.scales.yAxes[0].ticks.stepSize =
      Math.max(...this.chartdata.datasets[0].data) / 3;

    this.chartdata.labels = this.months;
    this.chartdata.datasets[0].data = this.profits;
    this.chartdata.datasets[0].backgroundColor = colours;

    this.renderChart(this.chartdata, this.options);
  }
};
</script>